import { createQuery } from 'react-query-kit';

import type { GetCurrentPlanOptionsResponse } from '@/api/gen/_model/getCurrentPlanOptionsResponse';
import { getCurrentPlanOptions } from '@/api/gen/quiz-plans/quiz-plans.gen';
import { type UserInfo } from '@/types';

import { type MappedPlanDetail, mapPlanDetail } from '../mapPlanDetail';
import { mapWorkspaceDetail } from '../mapWorkspaceDetail';

export const UseSubscribeUserPlanKey = ['subscribe-user-plan'];

export const useSubscribeUserPlan = createQuery<
  Awaited<ReturnType<typeof getCurrentPlanOptions>>,
  void
>({
  queryKey: UseSubscribeUserPlanKey,
  fetcher: async () => {
    return getCurrentPlanOptions();
  },
  // 실질적으로 영향을주면 안되서 false 로 설정
  meta: { ignoreError: true },
  throwOnError: false,
  enabled: false,
  refetchOnMount: 'always',
  refetchOnWindowFocus: 'always',
});

/**
 * 반환 타입을 손으로 나열한 `Pick` 으로 쓰지 않는다.
 *
 * 예전 시그니처는 필드명을 직접 열거해서, `UserInfo` 에 플랜 필드를 추가해도 여기서는
 * 컴파일 에러가 나지 않았다. 그러면 부팅(`/auth/profile`)에는 값이 실리지만 상시 갱신되는
 * 이 응답에는 실리지 않아, 값이 조용히 stale 해진다. {@link MappedPlanDetail} 에서
 * 파생시켜 `mapPlanDetail` 이 채우는 필드가 자동으로 따라오게 한다.
 */
export const transformCurrentPlanOptions = (
  planInfo: GetCurrentPlanOptionsResponse,
): MappedPlanDetail & Pick<UserInfo, 'workspace'> => ({
  ...mapPlanDetail(planInfo.plan),
  workspace: mapWorkspaceDetail(planInfo.workspace),
});
